import React, { useState } from "react";
import config from "../../config.json";
import globalWebSocketService from "../services/globalWebSocketService";
import petition_user from "../pages/home/petitions/petition_user";
import {
  WrenchScrewdriverIcon,
  XMarkIcon,
  PhoneArrowDownLeftIcon,
  PhoneArrowUpRightIcon,
} from "@heroicons/react/24/outline";

export default function DevToolbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  // Don't render in non-production environments
  if (config.production) return null;

  const simulateIncomingCall = async (withContact = true) => {
    if (!withContact) {
      globalWebSocketService.dispatchCustomEvent("incoming_call", {
        caller_number: "+18005559999",
        caller_name: null,
        contact: null,
        account: null,
        recent_tickets: [],
        uniqueid: `${Date.now()}.99999`,
      });
      return;
    }

    setLoading(true);
    try {
      // Fetch real open tickets for account pk=1
      const { data } = await petition_user(
        "ticket-management",
        "tickets?account_id=1&limit=10"
      );
      const allTickets = data?.result?.results || data?.result?.model_list || data?.result || [];
      const recentTickets = (Array.isArray(allTickets) ? allTickets : [])
        .filter((t) => t.status !== "closed" && !t.is_deleted)
        .slice(0, 10)
        .map((t) => ({
          pk: t.pk,
          title: t.title,
          status: t.status,
          priority: t.priority,
          created: t.created,
        }));

      globalWebSocketService.dispatchCustomEvent("incoming_call", {
        caller_number: "+13055551234",
        caller_name: "Caesar Engroba",
        contact: {
          pk: 1,
          firstname: "Caesar",
          lastname: "Engroba",
          email: "cengroba@gmail.com",
          phone: "3055551234",
        },
        account: {
          pk: 1,
          name: "Sarah Belalia & Associates",
        },
        recent_tickets: recentTickets,
        uniqueid: `${Date.now()}.12345`,
      });
    } catch (err) {
      console.error("DevToolbar: Failed to fetch tickets", err);
      // Fire anyway with no tickets
      globalWebSocketService.dispatchCustomEvent("incoming_call", {
        caller_number: "+13055551234",
        caller_name: "Caesar Engroba",
        contact: {
          pk: 1,
          firstname: "Caesar",
          lastname: "Engroba",
          email: "cengroba@gmail.com",
          phone: "3055551234",
        },
        account: {
          pk: 1,
          name: "Sarah Belalia & Associates",
        },
        recent_tickets: [],
        uniqueid: `${Date.now()}.12345`,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tw-fixed tw-bottom-6 tw-left-6 tw-z-[9999]">
      {isOpen ? (
        <div className="tw-bg-gray-900 tw-rounded-2xl tw-shadow-2xl tw-ring-1 tw-ring-gray-700 tw-p-4 tw-w-72">
          <div className="tw-flex tw-items-center tw-justify-between tw-mb-3">
            <div className="tw-flex tw-items-center tw-gap-2">
              <WrenchScrewdriverIcon className="tw-w-4 tw-h-4 tw-text-amber-400" />
              <span className="tw-text-sm tw-font-semibold tw-text-white">Dev Tools</span>
            </div>
            <button
              onClick={() => setIsOpen(false)}
              className="tw-rounded-full tw-p-1 tw-text-gray-400 hover:tw-bg-gray-700 hover:tw-text-white"
            >
              <XMarkIcon className="tw-w-4 tw-h-4" />
            </button>
          </div>

          <div className="tw-space-y-1.5">
            <p className="tw-text-xs tw-font-medium tw-text-gray-400 tw-uppercase tw-tracking-wider tw-mb-1">
              WebSocket Events
            </p>
            <button
              onClick={() => simulateIncomingCall(true)}
              disabled={loading}
              className="tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-rounded-lg tw-text-sm tw-text-gray-200 hover:tw-bg-gray-700 tw-transition-colors tw-text-left disabled:tw-opacity-50"
            >
              <PhoneArrowDownLeftIcon className="tw-w-4 tw-h-4 tw-text-green-400" />
              {loading ? "Loading..." : "Incoming Call (known contact)"}
            </button>
            <button
              onClick={() => simulateIncomingCall(false)}
              className="tw-w-full tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-rounded-lg tw-text-sm tw-text-gray-200 hover:tw-bg-gray-700 tw-transition-colors tw-text-left"
            >
              <PhoneArrowUpRightIcon className="tw-w-4 tw-h-4 tw-text-amber-400" />
              Incoming Call (unknown caller)
            </button>
          </div>
        </div>
      ) : (
        <button
          onClick={() => setIsOpen(true)}
          className="tw-w-10 tw-h-10 tw-rounded-full tw-bg-gray-900 tw-shadow-lg tw-ring-1 tw-ring-gray-700 tw-flex tw-items-center tw-justify-center hover:tw-bg-gray-800 tw-transition-colors"
          title="Dev Tools"
        >
          <WrenchScrewdriverIcon className="tw-w-5 tw-h-5 tw-text-amber-400" />
        </button>
      )}
    </div>
  );
}
